import React from 'react';
import { Button } from '@material-ui/core';
import { Card } from 'react-bootstrap';
import WarningIcon from '@material-ui/icons/Warning';

const CreatePortalPrompt = ({ portalFlag, onCreatePortal }) => {
    return (
        <Card className='p-4 cardHeight'>
            <div className="text-center p-4">
                <p>No client portal configuration found.</p>

                {!portalFlag && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'var(--badge-watch-bg)',
                        border: '1px solid #ffc107',
                        borderRadius: '4px',
                        padding: '12px 16px',
                        marginBottom: '16px',
                        color: 'var(--badge-watch-ink)'
                    }}>
                        <WarningIcon style={{ marginRight: '8px', color: '#ffc107' }} />
                        <span>
                            External Application Creation is disabled for this client.
                            Please enable the <strong>externalApplicationCreationEnabled</strong> flag in client settings before creating a portal.
                        </span>
                    </div>
                )}

                <Button
                    variant='contained'
                    color='primary'
                    onClick={onCreatePortal}
                    disabled={!portalFlag}
                >
                    Create Portal
                </Button>
            </div>
        </Card>
    );
};

export default CreatePortalPrompt;